import React, { useState, useEffect, useContext, useRef } from 'react';
import './LongestResponse.css';
import convenienceApi from '../../common/api/convenience';
import Card from '../Card/Card';
import CardContent from '../Card/CardContent';
import CardLink from '../Card/CardLink';
import CardLinkReport from '../Card/CardLinkReport';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { CardLongestResponseContext } from '../../contexts/CardLongestResponseContext';
import LongestResponseContent from './LongestResponseContent';
import LongestResponseTimeRange from './LongestResponseTimeRange';
import LongestResponseLoadingStatus from './LongestResponseLoadingStatus';
import logComponent from '../../common/logComponent';

export default function LongestResponse({ moduleDescription }) {
  const environmentContext = useContext(EnvironmentContext);
  //Note:  We are using context for data and time range because it wasn't updating the CardContent children when data changed or current time stamp changed
  const cardLongestResponseContext = useContext(CardLongestResponseContext);
  const { timeRanges } = cardLongestResponseContext;
  const [currentTimeRange, setCurrentTimeRange] = useState(timeRanges[0]);
  const { hasToken, activeUser: user, selectedUnit, selectedMonitoredIndividual, reportsEnabled } = environmentContext;
  const loadingRef = useRef(false);

  if (logComponent('LongestResponse')) { console.debug('LongestResponse rendered'); }

  const setLoadingRef = (el) => {
    if (logComponent('LongestResponse')) { console.debug('LongestResponse setLoadingRef'); }
    loadingRef.current = el;
  }
  useEffect(() => {
    if (logComponent('LongestResponse')) {console.debug('LongestResponse onMount'); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (!hasToken) return;

    loadAlarmers();
  }, []);

  useEffect(() => {
    if (logComponent('LongestResponse')) {console.debug('LongestResponse useEffect [currentTimeRange ]'); }
    if (!hasToken) return;

    loadAlarmers();

  }, [currentTimeRange]);

  useEffect(() => {
    if (logComponent('LongestResponse')) {console.debug('LongestResponse useEffect [environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit ]'); }
    if (!hasToken ) return;

    if (currentTimeRange !== timeRanges[0]) {
      setCurrentTimeRange(timeRanges[0])
    } else {
      loadAlarmers();
    }

  }, [environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit]);


  const loadAlarmers = () => {
    if (logComponent('LongestResponse')) {console.debug('LongestResponse loadAlarmers'); }
    if (loadingRef.current) return;
    setLoadingRef(true);
    const { setLongestResponse, setLongestResponseMonitoredIndividualsAndUnits, setLongestResponseLoading, setLongestResponseError } = cardLongestResponseContext;
    let days = null;

    switch (currentTimeRange) {
      case 'Past 7 days':
        days = 7;
        break;
      case 'Past 30 days':
        days = 30;
        break;
      default:
        break;
    }

    setLongestResponseMonitoredIndividualsAndUnits(null);
    setLongestResponse(null);
    setLongestResponseLoading(true);
    setLongestResponseError(false);


    convenienceApi.getLongestResponseData(days)
      .then(
        result => {

          setLongestResponseMonitoredIndividualsAndUnits(result.map(item => item.monitoredIndividual ? item.monitoredIndividual : item.unit));
          setLongestResponse(result);
          setLongestResponseLoading(false);
          setLongestResponseError(false);
          setLoadingRef(false);
        },
        error => {
          setLongestResponseMonitoredIndividualsAndUnits(null);
          setLongestResponse(null);
          setLongestResponseLoading(false);
          setLongestResponseError(true);
          setLoadingRef(false);
        }
      );
  }

  const updateTimeRange = (newRange) => {
    if (logComponent('LongestResponse')) {console.debug('LongestResponse updateTimeRange'); }
    const { setLongestResponseTimeRange } = cardLongestResponseContext;
    setLongestResponseTimeRange(newRange);
    setCurrentTimeRange(newRange);
  }



  return (
    <Card className="Longest-Response" title="Longest response" moduleDescription={moduleDescription} icon="exclamation-triangle">
      <CardContent>
        <LongestResponseTimeRange updateTimeRange={ updateTimeRange } />
        <LongestResponseContent />
        <LongestResponseLoadingStatus reloadAction={loadAlarmers} />
      </CardContent>
      {
        user.groupTypeString !== 'Family' && reportsEnabled &&
        <CardLink>
            <CardLinkReport reportId={ 5 } />
        </CardLink>
      }
    </Card>
  )
}
